// extracted by mini-css-extract-plugin
export default {"positive":"cm-value_positive__Q1Glk","negative":"cm-value_negative__ehQ-G","zero":"cm-value_zero__Luuhk"};